// Story 3.7d — shared card grid: WAU, active users, flagged incidents,
// inference cost placeholder. Used by both community and organization pages.
import { Card, Col, Row, Statistic } from 'antd';
import { BidiText } from '@lebinatikra/rtl-utils';
import { useTranslation } from 'react-i18next';
import type { DashboardMetricsData } from './use-dashboard-metrics';

export function DashboardCards({ metrics }: { metrics: DashboardMetricsData }) {
  const { t } = useTranslation();
  return (
    <Row gutter={[16, 16]} data-testid="dashboard-cards">
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title={<BidiText>{t('dashboard.metrics.wau')}</BidiText>}
            value={metrics.wau}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title={<BidiText>{t('dashboard.metrics.activeConversations')}</BidiText>}
            value={metrics.activeConversations}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <BidiText>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>
              {t('dashboard.metrics.flaggedIncidents')}
            </div>
          </BidiText>
          <Statistic
            title={<BidiText>{t('dashboard.metrics.flaggedLast24h')}</BidiText>}
            value={metrics.flaggedIncidents.last24h}
            data-testid="flagged-24h"
          />
          <Statistic
            title={<BidiText>{t('dashboard.metrics.flaggedLast7d')}</BidiText>}
            value={metrics.flaggedIncidents.last7d}
            data-testid="flagged-7d"
            style={{ marginTop: 8 }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title={<BidiText>{t('dashboard.metrics.inferenceCost')}</BidiText>}
            value={
              metrics.costMetricAvailable && metrics.inferenceCost !== null
                ? metrics.inferenceCost
                : t('dashboard.metrics.comingSoon')
            }
            valueStyle={metrics.costMetricAvailable ? undefined : { fontSize: 16, opacity: 0.6 }}
          />
        </Card>
      </Col>
    </Row>
  );
}
